import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
  getNewDate() {
    return new Date();
  }
}
